import { render } from "./DashboardFooter.vue?vue&type=template&id=b4a72626"
import script from "./DashboardFooter.vue?vue&type=script&lang=js"
export * from "./DashboardFooter.vue?vue&type=script&lang=js"

import "./DashboardFooter.vue?vue&type=style&index=0&id=b4a72626&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__